import $ from 'jquery';
import Dropdown from './dropdown';

export default class ProductFilterList {
  constructor() {
    this.constructor.createProductFilterListVueApp();
  }

  static createProductFilterListVueApp() {
    if (!$('#vue-product-filter-list').length) {
      return;
    }

    const app = new window.Vue({
      el: '#vue-product-filter-list',
      data: {
        products: window.productsLocalized,
        filters: window.productFiltersLocalized,
        postsPerPage: 8,
        postCount: 8,
        loading: true,
      },
      computed: {
        totalNoPosts: function () {
          return this.products.length;
        },
        selectedFilters: function () {
          return this.filters.filter(f => f.value.length > 0).map(f => f.value);
        },
        productsFiltred: function () {
          if (this.selectedFilters.length === 0) {
            return this.products;
          }

          return this.products.filter((product) => {
            const filters = product.filters.map(filter => filter.id);

            return this.selectedFilters.filter((sf) => {
              return sf.filter((s) => {
                return filters.indexOf(s) !== -1;
              }).length > 0;
            }).length === this.selectedFilters.length;
          });
        },
      },
      mounted() {
        $('.js--inverted-hover').on('mouseover mouseout', '.js-inverter', (e) => {
          $(e.target).closest('.js--inverted-hover').toggleClass('js--inverted-hover-active');
        });

        new Dropdown();
      },
      methods: {
        cardSize(product) {
          return this.selectedFilters.length === 0 ? 'filter-item--' + product.size : 'filter-item--small';
        },
        loadMore() {
          this.postCount = this.postCount + this.postsPerPage;
        },
        clearFilters() {
          this.filters.forEach((filter) => {
            filter.value = [];
          });
        },
      },
    });
  }
}
